import { DepartmentEnum } from "@/Common/constants/DepartmentEnum";
import { getPositionsByDepartments, getRawPositions, SALES_DEPARTMENTS, SERVICE_DEPARTMENTS } from "@/Common/helpers/Positions";
import { useManagedPositions } from "@/Common/hooks/Positions";
import { useMemo } from "react";

interface UseLocalPositionsOptions {
	positionType?: string;
	queryKeys?: string[];
	queryOpts?: object;
}

interface UseLocalPositionsResult {
	positions: string[];
	isLoading: boolean;
}

export function useLocalPositions(options: UseLocalPositionsOptions = {}): UseLocalPositionsResult {
	const { positionType, queryKeys = [], queryOpts = {} } = options;

	const {
		data: managedPositions,
		isPending,
	} = useManagedPositions({
		queryKeys,
		queryOpts: {
			staleTime: Infinity,
			...queryOpts,
		},
	} as any);

	const safePositions = useMemo((): string[] => getRawPositions(managedPositions ?? []), [managedPositions]);

	const departmentPositions = useMemo((): string[] | null => {
		if (!positionType) return null;
		const departments = positionType === DepartmentEnum.SALES ? SALES_DEPARTMENTS : SERVICE_DEPARTMENTS;
		return getPositionsByDepartments(departments, true);
	}, [positionType]);

	const positions = useMemo((): string[] => {
		if (!departmentPositions) return safePositions;
		const departmentSet = new Set(departmentPositions);
		return safePositions.filter((position: string) => departmentSet.has(position));
	}, [safePositions, departmentPositions]);

	return { positions, isLoading: isPending };
}
